import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { ReactNode } from "react";
export interface StepPropsType extends GeneralPropsType {
  icon?: ReactNode;
}
export interface TimeLinePropsType extends GeneralPropsType {
  length?: number;
}
export function Step({
  children,
  className
}: StepPropsType) {
  return <div data-sentry-component="Step" data-sentry-source-file="index.tsx">{children}</div>;
}
function TimeLine({
  children,
  className,
  length = 0
}: TimeLinePropsType) {
  return <div className={clsx("relative pl-2.5 ml-1", styles.container, className)} data-sentry-component="TimeLine" data-sentry-source-file="index.tsx">
            {length == 1 && <div className={clsx("absolute border-dashed left-0 top-[22px] bottom-[22px] border-l-2 border-current", styles.dot)}></div>}
            {children}
            {length > 1 && <div className={clsx("absolute border-dashed left-0 top-6 bottom-6 border-l-2 border-current", styles.arrow)}></div>}
        </div>;
}
export default TimeLine;